import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
/////firebase modulos////////
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import {AngularFireStorageModule} from '@angular/fire/storage';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { environment } from '../environments/environment';
///////charts.js//////////////////////////////////////////
import { ChartsModule } from 'ng2-charts';
///////////////////dragndrop////////////////////////////////////////////////////////
import {DragDropModule} from '@angular/cdk/drag-drop'; 
///////////////////////////////////////////////////////////////////////////
import { RegistrousuarioComponent } from './componentes/registrousuario/registrousuario.component';
import { LoginComponent } from './componentes/login/login.component';
import { MenuusuarioComponent } from './componentes/menuusuario/menuusuario.component';
import { SeccionMisactividadesComponent } from './componentes/seccion-misactividades/seccion-misactividades.component';
import { SeccionAjustesComponent } from './componentes/seccion-ajustes/seccion-ajustes.component';
import { SeccionHistorialComponent } from './componentes/seccion-historial/seccion-historial.component';
import { EditorsopaComponent } from './componentes/editorsopa/editorsopa.component';
import { AccesoactividadComponent } from './componentes/accesoactividad/accesoactividad.component';
import { RealizadorsopaComponent } from './componentes/realizadorsopa/realizadorsopa.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EditorsecuenciaComponent } from './componentes/editorsecuencia/editorsecuencia.component';
import { RealizadorsecuenciaComponent } from './componentes/realizadorsecuencia/realizadorsecuencia.component';
import { EditorcuestionarioComponent } from './componentes/editorcuestionario/editorcuestionario.component';
import { RealizadorcuestionarioComponent } from './componentes/realizadorcuestionario/realizadorcuestionario.component';
import { SeccionPresentacionComponent } from './componentes/seccion-presentacion/seccion-presentacion.component';



@NgModule({
  declarations: [
    AppComponent,
    RegistrousuarioComponent,
    LoginComponent,
    MenuusuarioComponent,
    SeccionMisactividadesComponent,
    SeccionAjustesComponent,
    SeccionHistorialComponent,
    EditorsopaComponent,
    AccesoactividadComponent,
    RealizadorsopaComponent,
    EditorsecuenciaComponent,
    RealizadorsecuenciaComponent,
    EditorcuestionarioComponent,
    RealizadorcuestionarioComponent,
    SeccionPresentacionComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ChartsModule,
    DragDropModule,
    FormsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFirestoreModule,
    AngularFirestoreModule,
    AngularFireStorageModule,
    BrowserAnimationsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
